<app-form (submit)="updateInfo()" data-modal-backdrop-static>
    <div class="card">
        <div class="card-header details-modal-header">
            <h3 class="card-header-title">
                <app-connection-image [connectionType]="info.connectionType"></app-connection-image>
                Connection information</h3>
            <div class="details-modal-close-zone">
                <button type="button" class="btn-close details-modal-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-md-6">
                    <app-form-field label="Location">
                        <app-search [minCharacters]="0" [(ngModel)]="location" required [searchFunction]="searchLocation"
                                    [inputFormatter]="refDataUtils.locationEntityFormatter" dataKey="location.info.name" (ngModelChange)="onLocationSelected($event)"
                                    placeholder="Search for a location" [disabled]="!isNewConnection"></app-search>
                    </app-form-field>
                </div>
                <ng-container *ngIf="location">
                    <div class="col-12 col-md-6">
                        <app-form-field label="Type">
                            <app-select required [(ngModel)]="info.connectionType" [options]="connectionTypes"
                                        [disabled]="!newConnectionId && !appContext.isAdmin()"></app-select>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Code">
                            <input required [(ngModel)]="info.code" type="text" class="form-control"
                                   [disabled]="!newConnectionId && !appContext.isAdmin()">
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Label">
                            <input [(ngModel)]="info.label" type="text" class="form-control">
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Market segment">
                            <app-select class="notranslate" [(ngModel)]="info.marketSegment" [options]="marketSegments"></app-select>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Supplier">
                            <app-service-provider-select class="notranslate" [type]="'supplier'" [(ngModel)]="info.supplier"></app-service-provider-select>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Operator">
                            <app-service-provider-select class="notranslate" [type]="'operator'" [(ngModel)]="info.operator"></app-service-provider-select>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field label="Supplier contract">
                            <input [(ngModel)]="info.supplierContract" type="text" class="form-control">
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-form-field>
                            <div class="formGroupLabel d-flex align-items-center gap-2">
                                <label class="fw-regular mb-0">Data source</label>
                                <button *ngIf="showUploadHistory" type="button" class="btn btn-link btn-sm text-muted p-0 upload-history-access notranslate"
                                        [disabled]="!canOpenUploadHistory" (click)="openUploadHistory()"
                                        [title]="uploadHistoryText(canOpenUploadHistory ? 'Manage uploads' : 'Save the connection first')"
                                        [attr.aria-label]="uploadHistoryText('Manage uploads')">
                                    <i class="bi bi-clock-history" aria-hidden="true"></i>
                                </button>
                            </div>
                            <app-service-provider-select class="notranslate" [required]="true" [type]="'surveyor'" [(ngModel)]="info.surveyor" (ngModelChange)="loadCoolingMeters()"></app-service-provider-select>
                            <small *ngIf="showUploadHistory && !canOpenUploadHistory" class="text-muted notranslate">{{uploadHistoryText('Save the connection first')}}</small>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6" *ngIf="canAddCooling && coolingMeters.length && appContext.isManagerForEntity(location)">
                        <app-form-field label="Cooling meter">
                            <app-select class="notranslate" [(ngModel)]="coolingMeter" [options]="coolingMeters"
                                        dataKey="uuid" [formatter]="coolingMeterFormatter" [nullOption]="true"
                                        [autoSelectSingleOption]="false"></app-select>
                        </app-form-field>
                    </div>
                    <div class="col-12 col-md-6"
                         *ngIf="info.connectionType === 'Electricity' && appContext.isAdminOrIntermediary()">
                        <app-form-field label="Submeter data source">
                            <app-service-provider-select class="notranslate" [type]="'submeterSurveyor'"
                                                         [(ngModel)]="info.submeterSurveyor"></app-service-provider-select>
                        </app-form-field>
                    </div>
                    <ng-container *ngIf="isEnecoConnection">
                        <div class="col-12 col-md-6">
                            <app-form-field label="Customer id">
                                <input [(ngModel)]="infoAsHeat.customerId" type="text" class="form-control" required>
                            </app-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <app-form-field label="Meter number">
                                <input [(ngModel)]="enecoMeterNumber" type="text" class="form-control">
                            </app-form-field>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="info.marketSegment === 'KV'">
                        <div class="h-100"></div>
                        <div class="col-12 col-md-6" >
                            <app-form-field label="Start date">
                                <app-date-field [(ngModel)]="info.desiredStartDate"
                                                defaultTime="00:00:00" [hideTime]="true"></app-date-field>
                            </app-form-field>
                        </div>
                    </ng-container>
                    <div class="col-12 col-md-6">
                        <app-form-field label="End date" tooltip="End date cannot be set in the past.">
                            <app-date-field [(ngModel)]="info.desiredEndDate" [dateOnly]="true" defaultTime="00:00:00" [atEndOfDay]="true" [minDate]="minDesiredEndDate"></app-date-field>
                        </app-form-field>
                    </div>
                </ng-container>
            </div>
            <div class="row">
                <ng-container *ngIf="info.connectionType">
                    <div class="col-12 col-md-6">
                        <ng-container *ngIf="info.marketSegment === 'KV' else gv">
                            <app-form-field label="Contracted capacity" [tooltip]="info.connectionValue ? null : 'Contracted capacity can be changed by selecting the correct connection value'">
                                <input [ngModel]="contractedCapacity" type="number" class="form-control" disabled>
                            </app-form-field>
                        </ng-container>
                        <ng-template #gv>
                            <app-form-field label="Contracted capacity">
                                <input [ngModel]="contractedCapacity" (ngModelChange)="info.contractedCapacity = $event" type="number" class="form-control"/>
                            </app-form-field>
                        </ng-template>
                    </div>
                </ng-container>
                <div class="col-12 col-md-6" *ngIf="info.connectionType === 'Electricity'">
                    <ng-container *ngIf="info.marketSegment === 'GV'">
                        <app-form-field label="Contracted feed-in capacity">
                            <input [(ngModel)]="infoAsElectricity.contractedFeedInCapacity" type="number" class="form-control">
                        </app-form-field>
                    </ng-container>
                </div>
            </div>

            <app-electricity-details *ngIf="info.connectionType === 'Electricity'" [info]="infoAsElectricity"></app-electricity-details>
            <section *ngIf="!isNewConnection && info.connectionType === 'Electricity' && appContext.isManagerForEntity(location)"
                     class="intermediate-meter-bulk mt-4">
                <h6 class="header-pretitle intermediate-meter-heading">Intermediate meters</h6>
                <div class="intermediate-meter-content">
                    <div class="intermediate-meter-status" [class.text-muted]="!intermediateMeters.length">
                        <i class="bi bi-speedometer2"></i>
                        <div>
                            <div class="intermediate-meter-count notranslate">{{ intermediateMeters.length }}</div>
                            <div class="intermediate-meter-description small">
                                Download and update the names and standard fields of the intermediate meters linked to this electricity connection.
                            </div>
                        </div>
                    </div>
                    <div class="intermediate-meter-actions">
                        <button type="button" class="btn btn-outline-primary"
                                [disabled]="!intermediateMeters.length" (click)="downloadIntermediateMeters()">
                            <i class="bi bi-download me-2"></i>Download intermediate meters
                        </button>
                        <label class="btn btn-outline-primary mb-0" [class.disabled]="!intermediateMeters.length">
                            <i class="bi bi-upload me-2"></i>Upload intermediate meters
                            <input type="file" hidden accept=".xlsx" [disabled]="!intermediateMeters.length"
                                   (change)="uploadIntermediateMeters($event)">
                        </label>
                    </div>
                </div>
                <div *ngIf="!intermediateMeters.length" class="intermediate-meter-empty mt-3" role="status">
                    <i class="bi bi-info-circle"></i>
                    <span>No intermediate meters are linked to this electricity connection.</span>
                </div>
            </section>
            <app-gas-details *ngIf="info.connectionType === 'Gas'" [info]="infoAsGas"></app-gas-details>
        </div>

        <div class="card-footer">
            <div class="d-flex justify-content-between">
                <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</app-form>
